/**
 */
export function InitialLoadingShell() {
  return (
    <div
      className="flex h-screen w-full items-center justify-center bg-background"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading"
    >
      <div className="relative h-12 w-12">
        <div
          className="absolute inset-0 animate-spin rounded-full border-4 border-muted border-t-primary"
          aria-hidden="true"
        />
      </div>
    </div>
  );
}
